module.exports = __webpack_public_path__ + "static/media/bulletins.b622146c.svg";